import { walletDeepLink } from '@account-service/core'
import { Button, Dialog, Intent, Shape } from '@axieinfinity/matcha'
import { LockOpenFillIcon } from '@axieinfinity/matcha-icons'
import { useState } from 'react'

import imgRonin from '~/public/images/ronin-blue.png'

type TWalletUnlockedModalProps = {
  visible: boolean
  universalLink?: string
  onClose: () => void
}

const WalletUnlockedModal: React.FC<TWalletUnlockedModalProps> = ({
  universalLink,
  visible,
  onClose,
}) => {
  const [isWalletConnected, setIsWalletConnected] = useState(false)
  const [isSigning, setIsSigning] = useState(false)

  return (
    <Dialog
      className="[&_.dango-dialog-content]:bg-surface-color-default [&_.dango-dialog-content]:border [&_.dango-dialog-content]:border-border-color-default [&_.dango-dialog-body]:p-0 [&_.dango-dialog-content]:!p-0 p-16 !w-[390px] sm:!w-[480px]"
      visible={visible}
      onClose={() => {
        setIsSigning(false)
        setIsWalletConnected(false)
        onClose()
      }}
      destroyOnClose
      size="small"
    >
      <div className="flex flex-col items-center text-center p-24">
        <div className="relative mt-20 mb-24">
          <img width={105} height={105} src={imgRonin} alt="warning" />
          <div className="absolute" style={{ right: 0, bottom: -12 }}>
            <LockOpenFillIcon size={32} />
          </div>
        </div>

        <div className="text-large leading-28 mb-4 font-semibold">
          Open Ronin Wallet
        </div>
        <div className="text-normal leading-20 text-text-color-subdued mb-24 font-medium">
          Your Digital Passport
        </div>

        {universalLink && (
          <>
            {(() => {
              if (!isWalletConnected)
                return (
                  <a className="w-full" href={universalLink}>
                    <Button
                      shape={Shape.Default}
                      intent={Intent.Primary}
                      className="w-full"
                      onClick={() =>
                        setTimeout(() => setIsWalletConnected(true), 500)
                      }
                      text="Open"
                    />
                  </a>
                )

              return (
                <a className="w-full" href={walletDeepLink}>
                  <Button
                    shape={Shape.Default}
                    intent={Intent.Primary}
                    className="w-full"
                    loading={isSigning}
                    onClick={() => setTimeout(() => setIsSigning(true), 500)}
                    text="Continue"
                  />
                </a>
              )
            })()}
          </>
        )}
      </div>
    </Dialog>
  )
}

export default WalletUnlockedModal
